<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">History for {{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" id="modal-body">
  <div class="mt-2" style="height: 60vh; overflow: scroll;">
    <div class="history-log-sec" *ngFor="let item of historyLog">
        <ngb-accordion #acc="ngbAccordion">
          <ngb-panel id="toggle-1"
            title="{{item.changedBy.displayName}} made a change on {{item.json.changedLogs?.entity || item.json?.entity}} at {{item.changedOn | localDate}}">
            <ng-template ngbPanelContent>
              <ng-template id="changedLogHistories" #changedLogHistories let-data="data">
                <strong class="text-capitalize">{{data.entity}}</strong>
                <div *ngIf="data?.changedLogs">
                  <div class="row" *ngFor="let data of data?.changedLogs">
                    <div class="col-4 text-capitalize">{{data.fieldName}}</div>
                    <div class="col-4">{{(data.fieldName === 'password') ? '******' : data.oldVal | json
                      }}</div>
                    <div class="col-4">{{(data.fieldName === 'password') ? '******' : data.newVal |
                      json}}</div>
                  </div>
                </div>
                <div *ngIf="data.changedLogHistories">
                  <div>{{data.entity}}</div>
                  <div *ngFor="let data of data.changedLogHistories">
                    <ng-container [ngTemplateOutlet]="changedLogHistories"
                      [ngTemplateOutletContext]="{data:data}"></ng-container>
                  </div>
                </div>
              </ng-template>
              <div class="row mt-2">
                <div class='col-4 font-weight-bold'>
                  Field
                </div>
                <div class="col-4 font-weight-bold">
                  Orignal value
                </div>
                <div class='col-4 font-weight-bold'>
                  New value
                </div>
              </div>
              <hr style="border-bottom-style: dashed;">
              <div class="row mt-2" *ngFor="let data of item.json?.changedLogs">
                <div class="col-4">{{data.fieldName}}</div>
                <div class="col-4">{{data.oldVal | json}}</div>
                <div class="col-4">{{data.newVal | json}}</div>
              </div>
              <hr style="border-bottom-style: dashed;">
              <div class="row mt-2" *ngFor="let data of item.json?.changedLogHistories">
                <div class="col-12 mt-2">
                  <ng-container [ngTemplateOutlet]="changedLogHistories"
                    [ngTemplateOutletContext]="{data:data}"></ng-container>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
  </div>
</div>
<div class="modal-footer confirm-footer">
    <!-- buttons for Cancel Confirmation Modal -->
    <button class="btn btn-primary btn-sm" type="button" (click)="close()">Cancel</button>
</div>
